import { useState } from 'react';
import { useTranslate } from 'react-polyglot';

import { BasicParagraph, Button, withPosition } from '@genially/design-system';
import { CloseIcon } from '@genially/icons';

import { CloseButton, StyledWarningIcon, Wrapper } from './ZeroParticipantsToast.styled';

interface ZeroParticipantsToastProps {
  numberOfParticipants: number;
  className?: string;
  onInvite?: () => void;
}

export const ZeroParticipantsToast = ({
  numberOfParticipants,
  className,
  onInvite,
}: ZeroParticipantsToastProps) => {
  const t = useTranslate();
  const [closedByUser, setClosedByUser] = useState(false);

  const handleOnInvite = () => {
    setClosedByUser(true);

    onInvite?.();
  };

  const handleClose = () => {
    setClosedByUser(true);
  };

  if (closedByUser || numberOfParticipants > 0) {
    return null;
  }

  return (
    <Wrapper className={className}>
      <StyledWarningIcon />
      <BasicParagraph> {t('__new.play.noParticipants.creator.tootip')}</BasicParagraph>
      <Button
        size={Button.Size.SMALL}
        variant={Button.Variant.STROKE}
        onClick={handleOnInvite}
      >
        {t('__new.play.noParticipants.creator.tootip.button')}
      </Button>
      <CloseButton onClick={handleClose} aria-label="Close">
        <CloseIcon />
      </CloseButton>
    </Wrapper>
  );
};

const ZeroParticipantsToastWithPosition = withPosition(ZeroParticipantsToast);

export default Object.assign(ZeroParticipantsToastWithPosition, {
  Placement: withPosition.Placement,
});
